export const generateShareLink = (exam, hash) => `${window.location.origin}/#/share-exam/${exam}/${hash}`